<template>
  <div class="page">
    <!-- 主体区域 -->
    <el-card>
      <!-- 筛选、操作区域 -->
      <OperationBar>
        <template slot="search-box">
          <el-form :model="queryForm" :inline="true">
            <el-form-item label="关键词">
              <el-input
                v-model="queryForm.search"
                placeholder="请输入关键词"
                clearable
                @keyup.enter.native="handleSearch()"
              ></el-input>
            </el-form-item>
            <el-form-item label="入库时间">
              <el-date-picker
                v-model="queryDate"
                type="daterange"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="dateChange"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
            </el-form-item>
          </el-form>
        </template>
      </OperationBar>

      <!-- 表格 -->
      <el-table ref="productListTable" :data="list" v-loading="loading" border>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="设备名称" prop="proName"></el-table-column>
        <el-table-column label="设备型号" prop="type"></el-table-column>
        <el-table-column label="包装序号" prop="serialNo"></el-table-column>
        <el-table-column label="所属订单" prop="orderNo"></el-table-column>
        <!-- <el-table-column label="状态" prop="proName">{{ status | storageDeviceStatusFilter }}</el-table-column> -->
        <el-table-column label="状态">已入库</el-table-column>
        <el-table-column label="入库时间" prop="storageTime"></el-table-column>
      </el-table>

      <!-- 分页器 -->
      <PaginationBar
        :pageNo.sync="pagination.pageNum"
        :pageSize.sync="pagination.pageSize"
        :total="pagination.total"
        @change="getList()"
      ></PaginationBar>
    </el-card>
  </div>
</template>

<script>
import { storageDeviceStatus } from '@/utils/data'

export default {
  name: '',
  components: {},

  props: {},

  data() {
    return {
      query: {},
      queryForm: {
        search: '',
        startDate: '',
        endDate: ''
      },
      storageDeviceStatus,
      queryDate: '',
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      list: []
    }
  },

  filters: {
    storageDeviceStatusFilter(val) {
      this.storageDeviceStatus.forEach((item, index) => {
        if (item.value === val) {
          return item.label
        } else {
          return '未知状态'
        }
      })
    }
  },

  computed: {},

  watch: {},

  created() {
    this.init()
    this.getList()
  },

  methods: {
    init() {
      const search = this.$route.query.search

      if (search) {
        this.query.search = search
        this.queryForm.search = search
      }
    },

    // 获取列表
    async getList() {
      this.loading = true
      const res = await this.$api.storage.getList({ ...this.query, ...this.pagination })
      this.loading = false
      if (res.code === '00000') {
        this.pagination.total = res.total
        this.list = res.data
      }
    },

    // 日期改变
    dateChange(e) {
      if (e) {
        this.queryForm.startDate = e[0]
        this.queryForm.endDate = e[1]
      } else {
        this.queryForm.startDate = ''
        this.queryForm.endDate = ''
      }

      this.handleSearch()
    },

    // 搜索事件
    handleSearch() {
      this.query = { ...this.queryForm }
      this.pagination.pageNum = 1
      this.getList()
    }
  }
}
</script>

<style scoped lang="scss">
.page {
}
</style>
